/**
 * Monthly hosting plan prices (USD cents). Bootstrap / marketing fallback.
 * Offline bootstrap only — live amounts come from GET /v1/sites/{slug}/plans (#744).
 * Go mirror: backend/internal/domain/hosting_billing.go (memory/seed fallback).
 * Values should match platform_stripe_prices migration seeds until API loads.
 */
export const HOSTING_PLAN_MONTHLY_CENTS = {
    payg: 0,
    starter: 1999,
    growth: 7900,
    pro: 14900,
};
/** Yearly hosting plan prices (USD cents). */
export const HOSTING_PLAN_YEARLY_CENTS = {
    foundation: 8999,
};
/**
 * Included API requests per calendar month before overage (#479).
 * PAYG has no pool. Starter stays 75k. Growth ~4× Starter; Pro ~13× (list-rate tiers).
 */
export const HOSTING_PLAN_INCLUDED_API_REQUESTS = {
    payg: 0,
    starter: 75_000,
    growth: 300_000,
    pro: 1_000_000,
};
/** @deprecated Prefer HOSTING_PLAN_INCLUDED_API_REQUESTS.starter */
export const STARTER_INCLUDED_API_REQUESTS_PER_MONTH = HOSTING_PLAN_INCLUDED_API_REQUESTS.starter;
/** Indicative overage rate: USD cents per 1,000 API requests (Starter / PAYG). */
export const METERED_OVERAGE_CENTS_PER_1K_REQUESTS = 15;
export function includedAPIRequestsForPlan(plan) {
    const key = plan.toLowerCase();
    if (key in HOSTING_PLAN_INCLUDED_API_REQUESTS) {
        return HOSTING_PLAN_INCLUDED_API_REQUESTS[key];
    }
    return HOSTING_PLAN_INCLUDED_API_REQUESTS.starter;
}
//# sourceMappingURL=hostingBilling.js.map